import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";

export function useIndicacionSectionColumns() {
  const detalleIndicacionInitialColumns = [
    { field: "idIndicacion", headerName: "ID indicación", flex: 100 },
    { field: "idInsumoN", headerName: "ID insumo", flex: 100 },
    { field: "insumo", headerName: "Insumo", flex: 100 },
    { field: "cantidad", headerName: "Cantidad", flex: 100 },
    { field: "unidad", headerName: "Unidad", flex: 100 },
  ];

  const detalleIndicacionColumns = generateColumnsDefaultConfiguration(
    detalleIndicacionInitialColumns,
    true
  );

  return detalleIndicacionColumns;
}
